export default "__VITE_ASSET__9HJKv6OJ__"